import { useParams } from 'react-router-dom'

import { AsyncBlock } from '../components/AsyncBlock'
import { ProjectHeading } from '../components/ProjectHeading'
import { api, type Selection } from '../lib/api'
import { fmtDate, humanize, statusClass } from '../lib/format'
import { useAsync } from '../lib/useAsync'

function SelectionRow({ selection }: { selection: Selection }): JSX.Element {
  return (
    <li className="row">
      <div className="row-main">
        <span className="row-title">{selection.display_name}</span>
        {selection.category && (
          <span className="row-sub">{humanize(selection.category)}</span>
        )}
      </div>
      <div className="row-meta">
        {selection.client_decision_value ? (
          <span className="row-dates">
            Chosen: {selection.client_decision_value}
          </span>
        ) : (
          selection.selection_deadline && (
            <span className="row-dates">
              Due {fmtDate(selection.selection_deadline)}
            </span>
          )
        )}
        <span className={`badge badge-${statusClass(selection.status)}`}>
          {humanize(selection.status)}
        </span>
      </div>
    </li>
  )
}

export function SelectionsPage(): JSX.Element {
  const { projectId = '' } = useParams()
  const state = useAsync(
    () => api.selections(projectId),
    `selections-${projectId}`,
  )
  return (
    <div className="page">
      <ProjectHeading projectId={projectId} title="Selections" />
      <AsyncBlock
        state={state}
        isEmpty={(d) => d.selections.length === 0}
        emptyText="No selections to show yet."
      >
        {(d) => (
          <ul className="row-list">
            {d.selections.map((s) => (
              <SelectionRow key={s.id} selection={s} />
            ))}
          </ul>
        )}
      </AsyncBlock>
    </div>
  )
}
